import { ThreadsIcon, BlueskyIcon, SubstackIcon } from '@buffer-mono/popcorn'

import type { JSX } from 'react'

/*
 * SERVICE DATA CONFIGURATION FOR ConnectAChannelModal
 */

export interface ServiceInfo {
  id: string
  label: string
  banner_img_url: string
  title: string
  description: string
  icon: JSX.Element
  buttonLabel: string
}

export interface ServiceData {
  [key: string]: ServiceInfo // This line allows any string to be used as an index
}

export const connectAChannelServiceData: ServiceInfo[] = [
  {
    id: 'threads',
    label: 'Threads',
    banner_img_url:
      'https://s3.amazonaws.com/buffer-publish/images/Connect-Channel-Onboarding-Modal/threads-banner.svg',
    title: 'Connect your Threads account',
    description:
      'Begin by logging into your Threads account to start creating & scheduling your posts.',
    icon: <ThreadsIcon />,
    buttonLabel: 'Connect to Threads',
  },
  {
    id: 'bluesky',
    label: 'Bluesky',
    banner_img_url:
      'https://s3.amazonaws.com/buffer-publish/images/Connect-Channel-Onboarding-Modal/bluesky-banner.svg',
    title: 'Connect your Bluesky account',
    description:
      'Begin by logging into your Bluesky account to start creating & scheduling your posts.',
    icon: <BlueskyIcon />,
    buttonLabel: 'Connect to Bluesky',
  },
  {
    id: 'substack',
    label: 'Substack',
    banner_img_url:
      'https://s3.amazonaws.com/buffer-publish/images/Connect-Channel-Onboarding-Modal/substack-banner.svg',
    title: 'Connect your Substack account',
    description:
      'Begin by logging into your Substack account to start creating & scheduling your Notes.',
    icon: <SubstackIcon />,
    buttonLabel: 'Connect to Substack',
  },
]
